import React, { useState, useEffect } from "react";
import { InputWithLabel } from "../../components/micro/input";

const EditRemarkModal = ({
  onClose,
  onConfirm,
  isLoading,
  remarkText = "",
  confirmText = "",
  width = "w-96",
  fontSize = "text-[34px]",
}) => {
  const [remark, setRemark] = useState(remarkText);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setRemark(remarkText);
    setIsEditing(false);
  }, [remarkText]);

  const handleEditClick = () => {
    setIsEditing(true);
  };

  const handleSaveClick = () => {
    onConfirm(remark); // Send updated remark to parent
    setIsEditing(false);
  };

  return (
    <>
      <div className="model" onClick={onClose}>
        <div
          className={`bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 mx-auto relative ${width}`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h2
            className={`${fontSize} font-Montserrat mb-3 text-center font-normal`}
          >
            {confirmText} Remark
          </h2>
          <div className="w-full mb-4">
            <InputWithLabel
              idFromName="remark"
              label="Remark"
              type="textarea"
              onChange={(e) => setRemark(e.target.value)}
              value={remark}
              className="text-black border hover:border-themeBtn
                transition duration-300 ease-in-out"
            />
          </div>
          <div className="flex justify-center gap-4 pt-3">
            <button
              onClick={onClose}
              type="button"
              className="text-themeBtn flex items-center uppercase font-Montserrat justify-center px-6 py-1.5 rounded border border-themeBtn"
            >
              <span>Cancel</span>
            </button>
            <button
              type="button"
              className={`flex items-center justify-center px-6 py-1.5 rounded font-Montserrat uppercase ${
                isLoading || (!isEditing && remark.trim() === "")
                  ? "bg-mGray text-borderGrey"
                  : "border-2 border-themeBtn rounded text-white bg-themeBtn"
              }`}
              disabled={isLoading || (!isEditing && remark.trim() === "")}
              onClick={handleSaveClick}
            >
              <span>Save</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditRemarkModal;
